import parse from "html-react-parser";
import { mergeClass } from "../../../utils";
import { ImageWithLoading } from "../../../components/ImageWithLoading";

const WorkOrPhotosPreview = ({
  itemData,
  forIndex,
}: {
  itemData: any;
  forIndex?: boolean;
}) => {
  const hasCaption =
    itemData.caption &&
    itemData.caption.length > 0 &&
    itemData.caption !== "<p><br></p>";
  return (
    <>
      {!forIndex && <div className="mt-4 font-medium">Preview</div>}
      <div className="relative w-64 h-64 bg-grayBg rounded-full border border-darkGrayBg overflow-hidden">
        <div className={"w-full h-full bg-black"}>
          {forIndex && itemData.thumbnail ? (
            <ImageWithLoading
              src={itemData.thumbnail}
              className="w-full h-full object-cover transform scale-125"
            />
          ) : itemData.imageUrl ? (
            <ImageWithLoading
              src={itemData.imageUrl}
              className="w-full h-full object-cover transform scale-125"
            />
          ) : (
            <div className="bg-grayBg h-full grid content-center text-center text-white">
              Select Image for preview
            </div>
          )}
        </div>
        {hasCaption && (
          <div className="absolute bottom-0 left-0 w-full h-auto bg-black text-white font-bold pt-1 flex justify-center">
            <div className="w-1/2 text-xs text-center mb-2 px-2 pb-1">
              {parse(itemData.caption)}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export { WorkOrPhotosPreview };
